import { forwardRef, useCallback } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { SnackbarContent, useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

const BasicInfoAlert = forwardRef(({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
        <SnackbarContent ref={ref}>
            <Alert severity="info" onClose={handleDismiss}>
                <AlertTitle>¡información!</AlertTitle>
                {props.message}
            </Alert>
        </SnackbarContent>
    );
});

BasicInfoAlert.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    message: PropTypes.string.isRequired
};

export default BasicInfoAlert;
